<template>
  <div class="navi">
    <b-navbar :class="{scroll: scrollPosition > 0}"
              fixed="top"
              toggleable="lg"
    >
      <b-navbar-brand to="/">
        <b-img src="../assets/images/logo.png"/>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/" v-scroll-to="'#app'">Start</b-nav-item>
          <b-nav-item to="/" v-scroll-to="'#contact'">Kontakt</b-nav-item>
          <b-nav-item to="/" v-scroll-to="'#services'">Leistungen</b-nav-item>
          <b-nav-item to="/" v-scroll-to="'#projects'">Projekte</b-nav-item>
          <b-nav-item to="/" v-scroll-to="'#team'">Team</b-nav-item>
          <b-nav-item to="/" v-scroll-to="'#carrier'">Karriere</b-nav-item>
          <b-nav-item to="/impressum">Impressum</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
  export default {
    name: 'Navbar',
    data() {
      return {
        scrollPosition: 0,
        scroll: false,
      }
    },
    methods: {
      updateScroll() {
        this.scrollPosition = window.scrollY
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    }
  }
</script>

<style lang="scss">
  @import '../assets/styles/navbar.scss';
</style>
